import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useWaitlistModal } from '../../context/WaitlistModalContext';

const NAV_LINKS = [
  { label: 'About', to: '/about' },
  { label: 'Features', to: '/features' },
  { label: 'Blog', to: '/blog' },
  { label: 'Updates', to: '/waitlist' },
];

const NavBar = () => {
  const { openWaitlistModal } = useWaitlistModal();
  const { pathname } = useLocation();

  return (
    <nav className="fixed top-0 left-0 w-full z-[100] px-8 py-6 flex justify-between items-center glass border-b-0">
      <Link to="/" className="font-bold tracking-[0.2em] text-lg text-white">SaniQ</Link>
      <div className="hidden md:flex gap-10 text-[10px] uppercase tracking-[0.3em] text-white/60">
        {NAV_LINKS.map((link) => (
          <Link
            key={link.to}
            to={link.to}
            className={`hover:text-cyan-400 transition-colors ${pathname === link.to ? 'text-white' : ''}`}
          >
            {link.label}
          </Link>
        ))}
      </div>
      <button
        onClick={openWaitlistModal}
        className="px-6 py-2 bg-white text-black text-[10px] font-bold uppercase tracking-widest rounded-full hover:bg-cyan-400 transition-all"
      >
        Register for Updates
      </button>
    </nav>
  );
};

export default NavBar;
